import type { SpecsFormOption } from "../../specsForm/types";
import { ProductLineType } from "../../../../types";

export const PRODUCT_VERSION_FACTORY_VALUES = [
  "AT",
  "ICX",
  "OW",
  "RI",
] as const;

export const PRODUCT_VERSION_PRODUCT_SEX_VALUES = [
  "Junior",
  "Unisex",
  "Woman",
  "Women",
  "junior",
] as const;

export const PRODUCT_VERSION_PRODUCT_LINE_VALUES = [
  ProductLineType.HYPER_CUSTOM,
  ProductLineType.ECO,
  ProductLineType.CLASSIC,
] as const;

export const PRODUCT_VERSION_STATUS_VALUES = [
  "active",
  "deprecated",
  "development",
] as const;
export const DEFAULT_PRODUCT_VERSION_STATUS = "development";

function createOptions<const TValue extends readonly string[]>(
  values: TValue
): SpecsFormOption[] {
  return values.map((value) => ({
    label: value,
    value,
  }));
}

export const PRODUCT_VERSION_FACTORY_OPTIONS = createOptions(
  PRODUCT_VERSION_FACTORY_VALUES
);

export const PRODUCT_VERSION_PRODUCT_SEX_OPTIONS = createOptions(
  PRODUCT_VERSION_PRODUCT_SEX_VALUES
);

export const PRODUCT_VERSION_PRODUCT_LINE_OPTIONS = createOptions(
  PRODUCT_VERSION_PRODUCT_LINE_VALUES
);

export const PRODUCT_VERSION_STATUS_OPTIONS = createOptions(
  PRODUCT_VERSION_STATUS_VALUES
);
